import React, { useLayoutEffect, useState } from "react";
import { useMediaQuery } from "beautiful-react-hooks";
import LandHeader from "./LandHeader";
import Footer from "./Footer";
import { useAuthDispatch } from "../Context/auth-context";
import { actionTypes } from "../Context/reducer";
import axios from "axios";

export function formatText(input) {
  const formattedText = input
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .join("<br />");

  // Print each line
  return formattedText;
}

export default function RulesAndRegulations() {
  const dispatch = useAuthDispatch();
  const [rulesText, setRulesText] = useState("");
  useLayoutEffect(() => {
    dispatch({
      type: actionTypes.LOGIN_REQUEST,
    });

    axios
      .get("https://api.sinatether.com/Auth/Getrules/", {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status == 200) {
          setRulesText(res.data.rules);
        }
      })
      .catch((error) => {
        if (error) {
          dispatch({
            type: actionTypes.LOGOUT,
          });
        }
      });
  }, []);

  const isSmall = useMediaQuery("(max-width: 768px)");

  var canonical = document.querySelector('link[rel="canonical"]');
  if (canonical !== null) {
    canonical.href = `https://sinatether.com/learnAuth`;
  }

  document.title = "قوانین و مقررات سیناتتر";
  document.getElementsByTagName("META")[3].content =
    "قوانین و مقررات سایت سینا تتر را مطالعه کنید تا با حقوق و تعهدات خود آشنا شوید. این صفحه تمامی شرایط استفاده از خدمات ما را به‌طور کامل توضیح می‌دهد.";

  return (
    <>
      <LandHeader />

      <div
        className={
          "mid-main text-center marginlr-140 learn-main-sina h2-size-title-learn  "
        }
      >
        <div className={""}>
          <h5 className={" h2-size-title-learn"}>قوانین و مقررات</h5>
        </div>

        <div className={"body pt-3 text-right"}>
          <div
            className={"dsjfk24242"}
            dangerouslySetInnerHTML={{ __html: formatText(rulesText) }}
          />
        </div>
      </div>

      <Footer />
    </>
  );
}
